import alasql from 'alasql'
import salesTable from './salesTable'

const moment = require('moment')
require('moment/locale/pt-br')

export default {
    methods: {
        /** Importa todas as funções de cálculos da tabela de vendas */
        ...salesTable.methods,

        /**
         * CALCULA VALOR DA ENTRADA UTILIZANDO REGRAS DO SIMULADOR
         * @param unitValue
         * @param entryValue
         * @param toleranceRules
         * @param rulesActive
         */
        facCalculateSimulatorValues(unitValue, entryValue, toleranceRulesAll, rulesActive, salesTableFlowId) {
            let percent
            let data = {}
            //CALCULAR A ENTRADA PEGA A PRIMEIRA DO OBJETO
            let toleranceRules = toleranceRulesAll[0]
            //PEGA VALOR REFERENTE ID DO FLUXO
            if (salesTableFlowId) {
                toleranceRules = alasql(`SELECT * FROM ? WHERE sales_table_flow_id= ${salesTableFlowId}`, [toleranceRulesAll])[0]
            }

            //VALOR DA ENTRADA INFORMADO
            if (entryValue) {
                percent             = this.facCalculatePercent(unitValue, entryValue)
                data.amount         = percent
            } else if (toleranceRules) {
                if (!rulesActive || rulesActive && toleranceRules.toleranceLevel !='weak') {
                    //SE VALOR DA ENTRADA NÃO FOI INFORMADO, PEGA VALOR E PORCENTAGEM
                    data.amount         = toleranceRules.amount
                    let newValueEntry   = unitValue * toleranceRules.amount / 100
                    data.entryValue     = newValueEntry
                }
            }

            //VERIFICA SE A ENTRADA É PARCELADA
            if (toleranceRules && toleranceRules.quota) {
                data.quota = toleranceRules.quota
            }

            //NÍVEL DE TOLERANCIA
            switch (toleranceRules && toleranceRules.toleranceLevel) {
                case 'strong':
                    //CALCULA O VALOR RFERENTE AS REGRAS DO SIMULADOR, RESPEITANDO A TOLERANCIA
                    if (percent < toleranceRules.amount) {
                        data.amount         = toleranceRules.amount
                        let newEntryValue  = (toleranceRules.amount / 100) * unitValue
                        data.entryValue     = newEntryValue
                        data.toleranceError = true
                        data.toleranceText  = `O valor da entrada não pode ser inferior a ${parseFloat(toleranceRules.amount)}%`
                    }
                    break
                case 'medium':
                    //CALCULA O VALOR USANDO O RESULTADO DA TOLERANCIA COMO BASE, RESPEITANDO
                    if (percent < toleranceRules.amountMin) {
                        data.amount         = toleranceRules.amountMin
                        data.entryValue     = (toleranceRules.amountMin / 100) * unitValue
                        data.toleranceError = true
                        data.toleranceText  = `O valor da entrada não pode ser inferior a ${parseFloat(toleranceRules.amountMin)}%`
                    }
                    break
                case 'weak':
                    //REGRA DA TOLERANCIA DESATIVADA, CALCULA O VALOR QUE O USUÁRIO INFORMAR
                    if (percent < toleranceRules.amount) {
                        data.toleranceError   = true
                        data.toleranceText    = `O valor da entrada está inferior a ${parseFloat(toleranceRules.amount)}%`
                    }
                    break
            }

            return data
        },

        /**
         * DEFINE VALORES PADRÃO PARA ENTRADA
         * @param selectedUnitValue
         * @param toleranceRules
         */
        facCalculateEntryDefault(selectedUnitValue, toleranceRules) {
            let data = []
            toleranceRules.forEach(function (rule) {
                //CRIA OBJETO COM OS VALORES DA ENTRADA
                let objectValue = {entry_value: selectedUnitValue * rule.amount / 100, percent: rule.amount}
                //MONTA ARRAY COM A KEY REFERENTE ID DO FLUXO, ENTRADA PERSONALIZADA
                data[rule.sales_table_flow_id] = objectValue
            })

            return data
        },

        /**
         * PEGA AS REGRAS DEFINIDA NO SIMULADOR POR TIPO
         * @param type
         */
        facGetRules(type, rules) {
            let entry = alasql(`SELECT * FROM ? WHERE type= "${type}"`, [rules])

            return entry
        },

        /**
         * CALCULA O VALOR DA CAPTAÇÃO COM REGRAS DO SIMULADOR, DEFINE O TIPO DA NOTIFICAÇÃO
         * @param selectedUnitValue
         */
        facCalculateCaptationDefault(selectedUnitValue, rulesCaptation, rulesAll) {

            //VERIFICA SE EXISTE REGRAS DO PV
            let pvRules               = this.facGetRules('present_value', rulesAll)
            let presentValueTolerance = this.facToleranceAmount(pvRules)
            //PEGA O CALOR DO PV PARA CALCULAR A CAPTAÇÃO
            if (presentValueTolerance && presentValueTolerance.length > 0) {
                let toleranceRules = presentValueTolerance[0]
                let newValue       = (toleranceRules.amount / 100) * selectedUnitValue

                if (toleranceRules.amountMin) {
                    newValue = (toleranceRules.amountMin / 100) * selectedUnitValue
                }
                selectedUnitValue  = newValue
            }

            rulesCaptation.valueUnit = selectedUnitValue
            //PEGA A QUANTIDADE DE MESES COM RELAÇÃO AOS DIAS INFORMADO NAS REGRAS DE CAPTAÇÃO
            rulesCaptation.installments       = this.facConvertDaysMonths(rulesCaptation.days)
            //PEGA O VALOR TOTAL DA CAPTAÇÃO, UTILIZANDO AS INFORMAÇÕES CADASTRADAS NAS REGRAS
            rulesCaptation.financialCaptation = this.facCalculatePercentFinancial(selectedUnitValue, rulesCaptation.amount)
            //PEGA O MENOR VALOR DA CAPTAÇÃO
            if (rulesCaptation.amountMin && rulesCaptation.toleranceLevel == 'medium') {
                rulesCaptation.financialCaptation = this.facCalculatePercentFinancial(selectedUnitValue, rulesCaptation.amountMin)
            }

            return rulesCaptation
        },

        /**
         * CALCULA O VALOR DO PV COM REGRAS DO SUMILADOR
         * @param selectedUnitValue
         * @param tableSalesFlow
         */
        facPresentValueRules(selectedUnitValue, rules) {
            let data = {validatePv: false}
            //REGRAS DO PV present_value
            let presentValueRules   = this.facGetRules('present_value', rules)
            //PEGA AS REGRAS DA TOLERANCIA REFERENTE AO VALOR PRESENTE
            let presentValueTolerance = this.facToleranceAmount(presentValueRules)
            if (presentValueTolerance && presentValueTolerance.length > 0) {
                let toleranceRules = presentValueTolerance[0]

                let valuePv = (toleranceRules.amount / 100) * selectedUnitValue

                if (toleranceRules.amountMin) {
                    valuePv = (toleranceRules.amountMin / 100) * selectedUnitValue
                }

                data.valuePv        = valuePv
                data.validatePv     = true
                data.toleranceLevel = toleranceRules.toleranceLevel
            }

            return data
        },

        /**
         * CALCULA A PORCENTAGEM DA ENTRADA USANDO O VALOR INFORMADO
         * @param unitValue
         * @param entryValue
         * @returns {number}
         */
        facCalculatePercent(unitValue, entryValue) {
            let newPercent = (entryValue * 100) / unitValue

            return newPercent
        },

        /**
         * DEFINE O NÍVEL DE TOLERANCIA CONFORME CADASTRO
         * @param value
         */
        facToleranceAmount(rules, unitValue, plus) {
            if (rules && rules.length > 0) {
                rules.forEach(function (rule) {
                    //VERIFICA SE NA REGRA TEM TOLERANCIA
                    if (rule.tolerance != '' && rule.tolerance != null) {
                        //TOLERANCIA ATIVADA
                        if (rule.tolerance == 0) {
                            rule.toleranceLevel = 'strong'
                        } else {
                            //TOLERANCIA VARIAVEL, TEM UM VALOR MINIMO
                            if (plus) {
                                rule.amountMax = parseFloat(rule.amount) + parseFloat(rule.tolerance)
                            } else {
                                rule.amountMin = parseFloat(rule.amount) - parseFloat(rule.tolerance)
                            }
                            rule.toleranceLevel = 'medium'
                        }
                    } else {
                        //REGRA DA TOLERANCIA DESATIVADA
                        rule.toleranceLevel = 'weak'
                    }

                    //ENTRADA COM VALOR FIXO PEGA O PERCENTUAL DA UNIDADE SELECIONADA
                    if (unitValue && rule.signal_value && rule.type == 'entry' && rule.type_rules == 'fixed-without-interest') {
                        rule.amount = rule.signal_value / unitValue * 100
                    }
                })
            }

            return rules
        },

        /**
         * RETORNA VALOR DA MULTIPLICAÇÃO
         * @param valueDefault
         * @param amount
         * @returns {number}
         */
        facCalculatePercentFinancial(valueDefault, amount) {
            let value

            value = parseFloat((amount / 100) * valueDefault)

            return value
        },

        /**
         * CALCULA VALORES DO BALÃO COM TAXA DE JUROS
         * @param unitValue
         * @param sales_table_flow_id
         * @param tableSalesFlow
         */
        facCalculateValueBaloon(unitValue, sales_table_flow_id, tableSalesFlow) {
            let result = {}

            //PEGA O FLUXO DO BALÃO REFERENTE AO FLUXO DA TABELA
            let quotesBaloon = alasql(`SELECT * FROM ? WHERE sales_table_flow_id= ${sales_table_flow_id}`, [tableSalesFlow.quotes_baloon])[0]

            //PEGA O VALOR DO BALÃO COM JUROS
            result.baloon_installments_value   = this.facCalculateValueFinancial(unitValue, quotesBaloon.sales_table_flow_id, quotesBaloon.percent, tableSalesFlow.quotes_baloon, tableSalesFlow)
            result.baloon_installments_percent = quotesBaloon.percent
            result.frequency                   = quotesBaloon.frequency
            result.quota                       = quotesBaloon.quota

            return result
        },

        /**
        *
        * @param unitValue
        * @param idFlow
        * @param percent
        * @param quotes
        * @param tableSalesFlow
        * @returns {number|*}
        */
        facCalculateValueFinancial(unitValue, idFlow, percent, quotes, tableSalesFlow, bankFinancing) {
            let rate = 0
            //PEGA A PERIODICIDADE EM MESES
            let flow      = alasql(`SELECT * FROM ? WHERE sales_table_flow_id = ${idFlow}`,[quotes])[0]
            //TABELA QUE TENHA FINANCIAMENTO BANCARIO
            if (bankFinancing) {
                flow.frequency = 'only-without-interest'
                flow.quota     = 1
            } else {
                rate = (flow.interest)? tableSalesFlow.monthly_rate : 0
            }

            let frequency = this.facGetFrequency(flow.frequency)
            let valueFinancial = this.facInstallmentPrice(unitValue, tableSalesFlow.type.toLowerCase(), (percent / 100), rate, frequency.period, flow.quota, 0, null, dataSimulation.simulation.first_installment_due_date)

            return valueFinancial
        },

        /**
        * QUANDO RATE FOR 0 NÃO CALCULA JURO, UTILIZA FUNÇÃO DO ARQUIVO calculationsTableSales.js
        * @param valueUnity
        * @param pmt
        * @param rate
        * @param quota
        * @returns {string|number}
        */
        facPercentFromPvWithoutInterest(valueUnity, pmt, rate, quota, type, offset = 0) {
            if (rate > 0 || rate < 0) {
                //PEGA O PERCENTUAL REFERENTE AO VALOR DIGITADO PARA TABELAS GRADIENTE
                if (type === 'sac') {
                    return this.facGetPercentageFromPvSac(valueUnity, pmt, rate, quota)

                } else if (type === 'sacoc') {
                    return this.facGetPercentageFromPvSacoc(valueUnity, pmt, rate, quota)

                } else if (type === 'vertical') {
                    return this.facGetPercentageFromPvVertical(valueUnity, pmt, rate, quota, offset)

                } else {
                    return this.facGetPercentageFromPv(valueUnity, pmt, rate, quota, offset)
                }

            } else {
                return this.facGetPercentFromPvWithoutInterest(valueUnity, pmt, quota)
            }
        },

        // monthDiff(d1, d2) {
        //     var months
        //     months = (d2.getFullYear() - d1.getFullYear()) * 12
        //     months -= d1.getMonth() + 1
        //     months += d2.getMonth()
        //     return months <= 0 ? 0 : months
        // }

        /**
         * RETORNA A DIFERENÇA ENTRE A DATA PADRÃO E A DATA SELECIONADA PELO USUÁRIO
         * @params type
         * @params paymentDate
         * @return paymentOffset
         **/
        facCalculateDiffDate(paymentDate, defaultDate, type) {

            let paymentOffset = 0
            let parcelType = this.facGetFrequency(type)
            // CALCULA A DATA DE PRORROGAÇÃO DAS PARCELAS DO TIPO BALÃO
            if (paymentDate) {
                // DIFERENÇA ENTRE AS DATAS EM MESES
                if (defaultDate) {
                    defaultDate = moment(defaultDate)

                } else if (['monthly', 'unique', 'intermediary'].includes(type) || parcelType.balloon) {
                    defaultDate = moment().add(parcelType.period, 'M')

                } else {
                    defaultDate = moment()
                }
                paymentDate = moment(paymentDate)

                // PEGA A DATA PADRÃO DE PRIMEIRA PARCELA
                let defaultMonth = defaultDate.get('month')
                let defaultYear = defaultDate.get('year')

                // PEGA A DATA INSERIDA PELO USUÁRIO
                let simulationMonth = paymentDate.get('month')
                let simulationYear = paymentDate.get('year')

                // DIFERENÇA ENTRE AS DATAS EM MESES/ANOS
                let yearDiff = (simulationYear - defaultYear) * 12
                let monthDiff = simulationMonth - defaultMonth

                paymentOffset = Math.floor(monthDiff + yearDiff)
            }

            return paymentOffset
        },
        /**
         * RETORNA A DIFERENÇA ENTRE A DATA PADRÃO E A DATA SELECIONADA PELO USUÁRIO
         * PARA O FLUXO VERTICAL
         *
         * @params type
         * @params paymentDate
         * @return paymentOffset
         **/
        facCalculateDiffDateVertical(paymentDate, defaultDate, type) {

            let paymentOffset = 0
            let parcelType = this.facGetFrequency(type)
            // CALCULA A DATA DE PRORROGAÇÃO DAS PARCELAS DO TIPO BALÃO
            if (paymentDate) {
                // DIFERENÇA ENTRE AS DATAS EM MESES
                if (defaultDate) {
                    defaultDate = moment(defaultDate)

                } else {
                    defaultDate = moment()
                }
                paymentDate = moment(paymentDate)

                paymentOffset = Math.floor(paymentDate.diff(defaultDate, 'days', true)  / 30 )
            }

            return paymentOffset
        },
        /**
         * RETORNA A DIFERENÇA ENTRE A DATA PADRÃO E A DATA SELECIONADA PELO USUÁRIO
         * PARA O FLUXO VERTICAL EM DIAS
         *
         * @params type
         * @params paymentDate
         * @return paymentOffset
         **/
        facCalculateDiffDateDay(paymentDate, defaultDate, type, valueVPL) {

            let paymentOffset = 0
            let parcelType = this.facGetFrequency(type)
            // CALCULA A DATA DE PRORROGAÇÃO DAS PARCELAS DO TIPO BALÃO
            if (paymentDate) {
                // DIFERENÇA ENTRE AS DATAS EM MESES
                if (defaultDate) {
                    defaultDate = moment(defaultDate)
                } else {
                    defaultDate = moment()
                }
                paymentDate = moment(paymentDate)

                const offset = Math.round(paymentDate.diff(defaultDate, 'days', true))
                paymentOffset = offset - (valueVPL * 30)
            }
            return paymentOffset
        },

        /**
        * IDENTIFICA QUAL O TIPO DE TABELA E RETORNA O VALOR COM JUROS
        * @param valueUnit
        * @param type
        * @param percent
        * @param rate
        * @param period
        * @param quota
        * @param fixedValue
        * @returns {number|*}
        * @constructor
        */
        facInstallmentPrice(valueUnit, type, percent, rate, period, quota, fixedValue, installments, paymentOffset, vplOffset = 0, dailyRate = false, dayOffset = 0) {
            if ((rate > 0) || (rate < 0)) {
                //CALCULA O VALOR DA PARCELA
                switch (type.toLowerCase()) {
                    case 'price':
                        return this.facGetInstallmentPrice((valueUnit * percent), rate, period, quota, installments, paymentOffset)

                    case 'sac':
                        return this.facGetInstallmentSac(( valueUnit * percent) , rate, quota, installments )

                    case 'sacoc':
                        return this.facGetInstallmentSacoc(( valueUnit * percent) , rate, quota, installments )

                    case 'vertical':
                        return this.facGetInstallmentVertical(
                            (valueUnit * percent),
                            rate,
                            period,
                            quota,
                            installments,
                            paymentOffset,
                            vplOffset,
                            dailyRate,
                            dayOffset
                        )
                }
            } else {

                //CALCULA VALOR DA PARCELA SEM CORREÇÃO
                return this.facValueWithoutInterestRate( valueUnit, percent, quota, fixedValue, installments )
            }
        },

        /**
        * RETORNA O NÚMERO REFERENTE AO MÊS / RETORNA O MÊS REFERENTE AO NÚMERO, RETORNA O MELHOR DIA DO VENCIMENTO
        * @param date
        * @param month
        * @returns {*}
        */
        facReturnNumberMonthOrDate(date, month, day, daysList, type, quota, ballon, quotaBallon, firstDateBallon, typeBallon, period) {
            let customDate   = false
            let result       = {quota: []}
            //PEGA A DATA PASSADA POR PARAMETRO OU DATA ATUAL
            let check        = moment(new Date())

            if (date) {
                check        = moment(date)
                customDate   = true
            }
                //PEGA O ANO ATUAL
            let currentYear  = check.format('YYYY')
            //PEGA O MÊS ATUAL
            let currentMonth = check.format('M')
            //PEGA O DIA DO MÊS
            let currentDay   = check.format('D')
            //DEFINE SE VAI SER CALCULADO MÊS OU ANO NA DATA
            let typeAddMoment= (type && type == 'yearly')? 'Y' : 'M'

            //RETORNA DATA COMPLETA REFERENTE AO NÚMERO DO MÊS QUE FOI INFORMADO
            if (month && !day) {
                //NO MOMENT JANEIRO INICIA COM 0, POR ISSO FOI RETIRADO UM NUMERO DA VARIAVEL MONTH
                month--
                result.date = moment().month(month)
            } else {
                //PEGA O NÚMERO DO MÊS
                result.month = (month)? month : currentMonth

                //SE EXISTIR LISTA COM OS DIAS
                if (daysList && daysList.length> 0) {
                    //FUNÇÃO PARA PEGAR O MAIOR VALOR DO ARRAY
                    let Max = function(array) {
                        return Math.max.apply(Math, array)
                    }
                    //FUNÇÃO PARA PEGAR O MENOR VALOR DO ARRAY
                    let Min = function(array) {
                        return Math.min.apply(Math, array)
                    }

                    //PEGA O NÚMERO DA LISTA MAIS PROXIMO AO DIA REFERENTE AO MÊS
                    result.day = daysList.reduce(function(prev, curr) {
                        if (parseInt(currentDay) > parseInt(Max(daysList))) {
                            return Min(daysList)
                        } else {
                            //PEGA O DIA MAIS PROXIMO
                            let bestDate = (Math.abs(curr - currentDay) < Math.abs(prev - currentDay) ? curr : prev)

                            //VERIFICA SE DIA É O MELHO PARA VENCIMENTO
                            if (parseInt(currentDay) > parseInt(bestDate)) {
                                return curr
                            }

                            return bestDate
                        }
                    })

                    //FORMATA DATA ATUAL
                    result.date = moment(`${currentYear}/${currentMonth}/${result.day}`, "YYYY-MM-DD").format('YYYY-MM-DD')
                    //MELHOR DATA DE VENCIMENTO FOR MENOR QUE O DIA DE HOJE, JOGA PARA PROXIMO MES
                    if (type == 'month') {
                        result.date = moment(result.date).add(1, 'M').format('YYYY-MM-DD')
                    }

                    if (type == 'yearly' || parseInt(month) < parseInt(currentMonth)) {
                        result.date = moment(result.date).add(1, 'Y').format('YYYY-MM-DD')
                    }
                }

                //PEGA A DATA REFERENTE AO DIA DE VENCIMENTO
                if (day) {
                    let newDay      = day
                    let newMonth    = (month)? month : currentMonth
                    let daysInMonth = moment(`${currentYear}-${newMonth}-${newDay}`, "YYYY-MM-DD").daysInMonth()

                    //ATUALIZA O DIA DO VENCIMENTO REFERENTE AO MÊS ESCOLHIDO
                    if (day > daysInMonth) {
                        newDay = daysInMonth
                    }

                    result.date = moment(`${currentYear}/${newMonth}/${newDay}`, "YYYY-MM-DD").format('YYYY-MM-DD')
                    result.day  = newDay

                    //SE DIA SELECIONADO FOR MENOR QUE O DIA CORRENTE
                    //JOGA VENCIMENTO PARA PROXIMO MES
                    if (!customDate && type == 'month') {// || parseInt(month) == parseInt(currentMonth) && parseInt(newDay) < parseInt(currentDay))) {
                        result.date = moment(result.date).add(1, 'M').format('YYYY-MM-DD')
                    }

                    //VERIFICA SE O MES SELECIONADO E MENOR QUE O MES CORRENTE
                    if (!customDate && parseInt(month) <= parseInt(currentMonth)) {
                        //MONTA NOVA DATA COM MES SELECIONADO
                        result.date = moment(`${currentYear}/${newMonth}/${newDay}`, "YYYY-MM-DD").format('YYYY-MM-DD')
                        //JOGA VENCIEMNTO PARA PROXIMO ANO
                        result.date = moment(result.date).add(1, 'Y').format('YYYY-MM-DD')
                    }
                }

                //GERA DATA DE VENCIMENTO DE TODAS AS PARCELAS
                if (quota) {
                    //VERIFICA SE OS BALOES PODE SER DIFERENTE DE ANUAL
                    // let countMomentDefault  = (type && type == 'yearly')? 12 : 1
                    //VERIFICA SE E BALAO, PODE SER DIFERENTE DE ANNUAL
                    // if (type !== 'month' && period) {
                    //     countMomentDefault = period
                    // }
                    let countMoment         = period
                    let key                 = 1

                    //PRIMEIRA PARCELA É FEITA NA REGRA ACIMA
                    result.quota[key] = result.date

                    for (let count = key; count < quota; count++) {
                        //PREPARA DATA PARA VENCIMENTO DIAS DIFERENTES, FALTA FINALIZAR
                        // let newDay1      = day
                        // let daysInMonth1 = moment(`${currentYear}-${countMoment}`).daysInMonth()
                        // //ATUALIZA O DIA DO VENCIMENTO REFERENTE AO MÊS ESCOLHIDO
                        // if (day > daysInMonth1) {
                        //     newDay1 = daysInMonth1
                        // }
                        //
                        // //MONTA NOVA DATA COM MES SELECIONADO
                        // let newDate = moment(`${currentYear}/${countMoment}/${newDay1}`, "YYYY-MM-DD").format('YYYY-MM-DD')
                        //
                        // key++
                        // //DATA DE VENCIMENTO COM DIA FIXO
                        // result.quota[key] = moment(newDate).add(countMoment, 'M').format('YYYY-MM-DD')
                        // countMoment = countMoment + countMomentDefault
                        // // console.log('Parcela ' + count + ': ' + moment(result.quota[count].date).format('DD/MM/YYYY'))
                        ////

                        key++
                        //DATA DE VENCIMENTO COM DIA FIXO
                        result.quota[key] = moment(result.date).add(countMoment, 'M').format('YYYY-MM-DD')
                        countMoment = countMoment + period
                        // console.log('Parcela ' + count + ': ' + moment(result.quota[count].date).format('DD/MM/YYYY'))
                    }
                }

                //GERA DATA DE VENCIMENTO DOS BALOES
                if (ballon) {
                    // let typeAddMomentBallon = (type && type == 'yearly')? 'Y' : 'M'
                    // let countMomentDefault  = (typeBallon && typeBallon == 'yearly')? 12 : 1
                    //VERIFICA SE BALAO PODE SER DIFERENTE DE ANNUAL
                    // if (period) {
                    //     countMomentDefault = period
                    // }
                    let countMoment   = period
                    result.ballon     = []
                    result.date       = firstDateBallon
                    let key           = 1
                    result.ballon[key] = result.date
                    for(let count = key; count < quotaBallon; count++) {
                        key++
                        //DATA DE VENCIMENTO COM DIA FIXO
                        result.ballon[key] = moment(result.date).add(countMoment, 'M').format('YYYY-MM-DD')
                        countMoment = countMoment + period
                        // console.log('Parcela balão' + count + ': ' + moment(result.ballon[count].date).format('DD/MM/YYYY'))
                    }
                }
            }

            return result
        },

        /**
        * CALCULA OS MESES ENTRE AS DATAS
        * @param date
        * @returns {string}
        */
        facDifferenceBetweenDates(date) {

            let newDate      = moment(new Date())
            let advancedDate = moment(date).add(24, 'hours').format('YYYY-MM-DD hh:mm:ss')
            let end          = moment(advancedDate)
            let duration     = moment.duration(end.diff(newDate))
            let months       = duration.asMonths()

            return months
        },

        /**
        * CALCULA SE A DATA QUE FOI INFORMADO NO VENCIMENTO DO BALAO ENTRA NO VALOR DA CAPTAÇÃO
        * @param installments
        * @param dateAll
        * @param date
        * @returns {number}
        */
        facFinancialCaptationDate(installments, dateAll, date) {
            let result   = 0

            if (dateAll && dateAll.length > 0) {
                for(let count = 0; count < dateAll.length; count++) {
                    let dateBallon = dateAll[count].date
                    let dateInstallments = this.facDifferenceBetweenDates(dateBallon)
                    if (installments >= dateInstallments) {
                        result++
                    }
                }
            }
            return result
        },

        /**
        * CONVERTE DIAS EM MESES
        */
        facConvertDaysMonths(days) {
            let month = days / 30

            return month
        },

        /**
        * CONVERTE DIAS EM ANOS
        */
        facConvertDaysYears(days) {
            let convert
            convert = days / 365
            return convert
        },

        /**
         * CALCULA O PMT DE UM BALÂO
         * 
         * @param {Float} rate 
         * @param {Integer} nPeriod 
         * @param {Float} pv 
         */
        facGetBalloonPMT(rate, nPeriod, pv) {
            const i = rate / 100
            const intRate = this.facGetInterestRate(rate, nPeriod)
            const pmt = pv * ((intRate * i) / (intRate - 1))
        
            return pmt
        },

        /**
         * RECEBE OS DADOS DE UMA PARCELA DO TIPO BALÂO E A PRORROGA
         * DE ACORDO COM O OFFSET EM MÊSES
         * 
         * @param {Integer} value 
         * @param {Integer} quota 
         * @param {String} type 
         * @param {Float} rate 
         * @param {Integer} offset 
         */
        facGetBalloonByDate(value, quota, type, rate, offset) {
            let interest = null
            if (!['intermediary', 'unique'].includes(type)) {
                const frequency = this.facGetFrequency(type)
                interest = this.facConvertInterest(rate, frequency.period)

            } else {
                interest = rate
            }
            const totalBalloon = this.facGetPv(value, interest, quota) / this.facGetInterestRate(rate, offset)
            // const balloonOffset = offset < frequency.period ? 0 : Math.floor(offset / frequency.period)
            // const adjustedQuota = parseInt(quota) - parseInt(balloonOffset)
            const fv = this.facGetFV(totalBalloon, rate, offset)
            const result = fv - totalBalloon
            // const result = this.facGetBalloonPMT(interest, parseInt(quota), fv)

            return result
        }
    }
}